import { mapState } from 'vuex'
import styles from './styles'
import mapBlurImage from './map-blur.jpg'
import markerIcon from './icon-map-marker.svg'
import config from '@/config'

let initGoogleMaps = false

export default {
  data () {
    return {
      isMap: false,
      mapImage: mapBlurImage,
      mapName: 'map',
      mapEl: null,
      panorama: null,
      styles: styles,
      markerIcon: markerIcon,
      fullscreenControl: true,
      zoomControl: true,
      mapTypeControl: true,
      visibleStreetView: false
    }
  },
  computed: {
    ...mapState('tours', ['map', 'ready'])
  },
  methods: {
    createGoogleMaps () {
      return new Promise((resolve, reject) => {
        let map = document.createElement('script')
        map.src = config.GOOGLE_MAPS_URL
        map.type = 'text/javascript'
        map.onload = resolve
        map.onerror = reject
        document.head.appendChild(map)
        initGoogleMaps = true
      })
    },
    initGoogleMaps () {
      const { lat, lng, zoom } = this.map

      const location = {lat, lng}

      const mapOptions = {
        center: location,
        zoom,
        disableDefaultUI: true,
        fullscreenControl: this.fullscreenControl,
        zoomControl: this.zoomControl,
        // mapTypeControl: this.mapTypeControl,
        // mapTypeControlOptions: {
        //   position: google.maps.ControlPosition.RIGHT_TOP
        // },
        fullscreenControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        styles: this.styles
      }

      const streetViewOptions = {
        position: location,
        addressControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        fullscreenControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        visible: this.visibleStreetView,
        linksControl: false,
        enableCloseButton: false
      }

      this.mapEl = new google.maps.Map(document.getElementById(this.mapName), mapOptions)
      this.panorama = new google.maps.StreetViewPanorama(document.getElementById(this.mapName), streetViewOptions)

      const image = {
        url: this.markerIcon,
        size: new google.maps.Size(48, 60)
      }

      new google.maps.Marker({
        map: this.mapEl,
        position: location,
        icon: image
      })
    },
    googleMapsFailedToLoad () {
      console.log('Google Maps failed to load.')
    },
    toggleStreetView () {
      this.visibleStreetView = !this.visibleStreetView
      this.panorama.setVisible(this.visibleStreetView)
    },
    showMap () {
      this.isMap = true

      if (!initGoogleMaps) {
        this.createGoogleMaps().then(this.initGoogleMaps, this.googleMapsFailedToLoad)
      } else {
        this.initGoogleMaps()
      }
    }
  }
}
